module.exports = __webpack_public_path__ + "img/sentry-secure-logo.069e1534.svg";